module.exports = __webpack_public_path__ + "static/media/Cabinet4_Before.47a4cc4e.jpg";